/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ViewLineupsQueryVariables = {|
  lineupSetID: string
|};
export type ViewLineupsQueryResponse = {|
  +numValidLineupsForLineupSet: ?{|
    +totalNumLineups: ?number,
    +validLineups: ?number,
    +yellowLineupsPresent: ?boolean,
    +redLineupsPresent: ?boolean,
  |}
|};
export type ViewLineupsQuery = {|
  variables: ViewLineupsQueryVariables,
  response: ViewLineupsQueryResponse,
|};
*/


/*
query ViewLineupsQuery(
  $lineupSetID: ID!
) {
  numValidLineupsForLineupSet(lineupSetId: $lineupSetID) {
    totalNumLineups
    validLineups
    yellowLineupsPresent
    redLineupsPresent
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lineupSetID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "lineupSetId",
        "variableName": "lineupSetID"
      }
    ],
    "concreteType": "LineupCountSummary",
    "kind": "LinkedField",
    "name": "numValidLineupsForLineupSet",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalNumLineups",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "validLineups",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "yellowLineupsPresent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "redLineupsPresent",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ViewLineupsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ViewLineupsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3dea06848fc216387714e01a170d002f",
    "id": null,
    "metadata": {},
    "name": "ViewLineupsQuery",
    "operationKind": "query",
    "text": "query ViewLineupsQuery(\n  $lineupSetID: ID!\n) {\n  numValidLineupsForLineupSet(lineupSetId: $lineupSetID) {\n    totalNumLineups\n    validLineups\n    yellowLineupsPresent\n    redLineupsPresent\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '64f1d6204bfe4626ba6776d07e57e259';

module.exports = node;
